<template>
	<div class="newBanner">

		<div class="breadcrumb">banner管理 >
			<span v-if="edit === false">新增</span>
			<span v-if="edit !== false">编辑</span>

			<el-button class="right_f" type="primary" @click="cancel">取消</el-button>
			<el-button class="right_f" type="primary" @click="save">保存为草稿</el-button>
			<el-button class="right_f" type="primary" @click="issue">保存并发布</el-button>

		</div>

		<div class="bannerDetail">
			<el-form class="bannerForm" ref="bannerForm" :rules="rules" :model="bannerForm" label-width="130px">

				<el-form-item label="封面图片：" prop="imgUrl">
					<el-upload :action="actionUrl" :with-credentials="true" accept="image/*" name="uploadFile"
						type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess">
						<i class="el-icon-upload"></i>
						<div class="el-dragger__text">将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>
					<span class="gray" v-if="bannerForm.positionType == 1">3.0.0版本之前的发现频道：（750x418，格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 2">跑步记录顶部：（750x270， 格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 3">运动音乐顶部：（750x270， 格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 4">首页-为你推荐：（584x240，格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 5">社区-动态：（686x240， 格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 6">3.0.0版本及之后的发现频道：（686x240， 格式为jpg、png）</span>
					<span class="gray" v-if="bannerForm.positionType == 7">问卷调查：（750x270，格式为jpg、png）</span>
				</el-form-item>

				<el-form-item label="位置：" prop="positionType" required>
					<el-select v-model="bannerForm.positionType" class='place'>
						<el-option label="3.0.0版本之前的发现频道" value='1'></el-option>
						<el-option label="跑步记录顶部" value='2'></el-option>
						<el-option label="运动音乐顶部" value='3'></el-option>
						<el-option label="首页-为你推荐" value='4'></el-option>
						<el-option label="社区-动态" value='5'></el-option>
						<el-option label="3.0.0版本及之后的发现频道" value='6'></el-option>
						<el-option label="问卷调查" value='7'></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="banner名称：" prop="title" style="margin-bottom: 18px;">
					<el-input v-model="bannerForm.title" placeholder="banner名称不在app上显示，仅供后台管理参考"></el-input>
				</el-form-item>

				<el-form-item label="广告曝光代码：" prop="adExposingCodes" class="bannerContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="在这里粘贴"
						v-model="bannerForm.adExposingCodes">
					</el-input>
				</el-form-item>

				<el-form-item label="点击事件：" prop="clickEvent" required class="wx-app">
					<el-radio v-model="bannerForm.clickEvent" label="-1">无跳转</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="5">跳转至URL：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="1">跳转至已有文章：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="2">跳转至已有话题：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="6">跳转至已有活动：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="7">跳转至微信小程序：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="9">跳转至支付宝小程序：</el-radio>
					<el-radio v-model="bannerForm.clickEvent" label="8">跳转至音频：</el-radio>

				</el-form-item>
				<el-form-item prop="keyWord" v-if="!shieldArray.includes(bannerForm.clickEvent)">
					<el-input v-model="bannerForm.keyWord" :placeholder="placeholder"></el-input>
				</el-form-item>
				<!-- 微信小程序 -->
				<div v-if="bannerForm.clickEvent == '7'" class="wx-app">
					<el-form-item label="小程序原始ID：" prop="wxAppId" class="wxApp-from wx-app" required>
						<el-input v-model="bannerForm.wxAppId" placeholder="请填写正确的小程序原始ID"></el-input>
					</el-form-item>
					<el-form-item label="路径地址：" class="wxApp-from">
						<el-input v-model="bannerForm.wxAppUrl" placeholder="请填写正确的路径地址"></el-input>
					</el-form-item>
				</div>
				<!-- 支付宝小程序 -->
				<div v-if="bannerForm.clickEvent == '9'" class="wx-app">
					<el-form-item label="小程序原始ID：" prop="aliAppId" class="wxApp-from wx-app" required>
						<el-input v-model="bannerForm.aliAppId" placeholder="请填写正确的小程序原始ID"></el-input>
					</el-form-item>
					<el-form-item label="路径地址：" class="wxApp-from">
						<el-input v-model="bannerForm.aliAppUrl" placeholder="请填写正确的路径地址"></el-input>
					</el-form-item>
				</div>
				<!-- 音频 -->
				<div v-if="bannerForm.clickEvent == '8'" class="wx-app">
					<el-form-item label="专辑ID：" class="wxApp-from" required>
						<el-input v-model="bannerForm.albumId" placeholder="请填写专辑ID"></el-input>
					</el-form-item>
					<el-form-item label="主播名称：" prop="nickName" class="wxApp-from wx-app" required>
						<el-input v-model="bannerForm.nickName" placeholder="请填写主播名称"></el-input>
					</el-form-item>
					<el-form-item label="单曲数：" class="wxApp-from" required>
						<el-input v-model="bannerForm.albumCount" placeholder="请填写单曲数" type="number"></el-input>
					</el-form-item>
					<el-form-item label="是否付费：" prop="isPaid" class="wxApp-from" required>
						<el-radio v-model="bannerForm.isPaid" label="1">是</el-radio>
						<el-radio v-model="bannerForm.isPaid" label="0">否</el-radio>
					</el-form-item>
				</div>
				<!-- 1 -->
				<select-school :schObj="bannerForm.schObj" @changeVal="getVal"></select-school>
			</el-form>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex'
	import { mapActions } from 'vuex'
	import selectSchool from "../../common/selectSch.vue"

	export default {
		data() {
			let checkStringNull = (rule, value, callback) => {
				if (value && value.trim()) {
					callback();
				} else {
					callback(new Error("输入不能为空"));
				}
			};

			return {
				actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=8',
				edit: false,
				bannerId: null,
				shieldArray: ["-1", "7", "8", "9"],
				bannerForm: {
					imgUrl: '',
					title: '',
					schObj: {
						applicableCampus: "1",
						shieldedSchools: [], //屏蔽的学校
						openedSchools: []//应用的学校
					},
					clickEvent: '-1',
					positionType: '1',
					adExposingCodes: "",
					keyWord: '',
					wxAppId: '',
					wxAppUrl: '',
					aliAppId: '',
					aliAppUrl: '',
					musicTag: "",
					musicType: "",
					albumId: "",
					nickName: "",
					albumCount: "",
					isPaid: '0'
				},
				rules: {
					imgUrl: [
						{ required: true, message: '请上传封面图片', trigger: 'change' }
					],
					title: [
						{ required: true, message: '请输入标题', trigger: 'blur' },
						{ min: 1, max: 50, message: '不超过50个字符', trigger: 'blur' },
						{ validator: checkStringNull }
					],
				},
			}
		},
		components: { selectSchool },
		mounted() {
			let url = window.location.href;

			if (url.indexOf('?') !== -1) {
				this.edit = true;
				this.bannerId = this.$util.getUrlParam('bannerId');
				this.getBannerDetail(this.bannerId);
			}

		},

		computed: {
			user() {
				return this.$store.state.user
			},

			placeholder() {
				if (this.bannerForm.clickEvent === '5') {
					return '请填写正确的url地址'
				} else if (this.bannerForm.clickEvent === '1') {
					return '请填写正确的文章id'
				} else if (this.bannerForm.clickEvent === '6') {
					return '请填写正确的活动地址'
				} else {
					return '请填写正确的话题id'
				}
			},
		},

		methods: {
			...mapActions(['SIGNOUT']),

			//获取子组件传递的参数
			getVal(res) {
				this.bannerForm.schObj = res;
			},
			/**上传图片成功钩子**/
			handleSuccess(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg('上传失败');
				} else {
					this.bannerForm.imgUrl = response.data;
				}
			},

			/**上传文件失败钩子**/
			handleError(response) {
				if (response.status === 403) {
					this.SIGNOUT();
					location.href = '/#';
				}
				this.$util.errorMsg('上传失败');
			},

			/**
			 * 取消
			**/
			cancel() {
				history.go(-1);
			},

			//提交前的判断
			preValid() {
				let promise = new Promise((resolve, reject) => {
					if (this.bannerForm.schObj.applicableCampus == '1' && this.bannerForm.schObj.openedSchools.length == 0) {
						this.$util.errorMsg("请添加应用学校");
						reject();
					}

					if (!this.shieldArray.includes(this.bannerForm.clickEvent) && !this.bannerForm.keyWord.trim()) {
						this.$util.errorMsg("点击事件的id或者url不能为空！");
						reject();
					}

					if (this.bannerForm.clickEvent === '7' && !this.bannerForm.wxAppId.trim()) {
						this.$util.errorMsg("微信小程序的原始id不能为空！");
						reject();
					}

					if (this.bannerForm.clickEvent === '7' && this.bannerForm.wxAppId.indexOf('id=') > -1) {
						this.$util.errorMsg("微信小程序的原始id输入格式错误！");
						reject();
					}
					if (this.bannerForm.clickEvent === '9' && !this.bannerForm.aliAppId.trim()) {
						this.$util.errorMsg("支付宝小程序的原始id不能为空！");
						reject();
					}

					if (this.bannerForm.clickEvent === '9' && this.bannerForm.aliAppId.indexOf('appId=') > -1) {
						this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
						reject();
					}

					if (this.bannerForm.clickEvent === '8') {
						var re = /^[0-9]+$/;
						if (!this.bannerForm.albumId.trim()) {
							this.$util.errorMsg("专辑ID不能为空！");
							reject();
						}
						if (!this.bannerForm.nickName.trim()) {
							this.$util.errorMsg("主播名称不能为空！");
							reject();
						}
						if (!this.bannerForm.albumCount || !re.test(this.bannerForm.albumCount)) {
							this.$util.errorMsg("单曲数输入有误！");
							reject();
						}
					}
					resolve();
				});
				return promise;
			},

			/**
			 * 保存并发布
			**/
			issue(ev) {
				this.preValid().then(() => {
					this.$refs.bannerForm.validate((valid) => {
						if (valid) {
							this.$confirm('确定要发布吗？发布后该篇会变成‘已发布’状态，且用户端将看到该篇内容', '发布', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.add(2);
							})
						}
					})
				}).catch(() => {
					//校验失败；
				})

			},

			/**
			 * 保存为草稿
			**/
			save() {
				this.preValid().then(() => {
					this.$refs.bannerForm.validate((valid) => {
						if (valid) {
							//直接保存
							this.add(1);
						}
					})
				}).catchj(() => {
					//校验失败
				})

			},

			getBannerDetail(bannerId) {
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v3/operate/banner/details',
					body: JSON.stringify({
						id: bannerId
					})
				}).then(response => {

					if (response.data.error !== 10000) {
						this.$util.errorMsg(response.data.message);
					} else {
						let data = response.data.data;
						let keyWord = '', wxAppId = '', wxAppUrl = '', aliAppId = '', aliAppUrl = '', albumId, nickName, albumCount, isPaid = '0';
						// 点击事件的ID或URL

						if (data.type === 5 || data.type === 6) {
							keyWord = data.targetUrl;
						} else if (data.type === -1) {
							keyWord = '';
						} else if (data.type === 7) {
							// 微信小程序地址拆分getUrlParam
							wxAppId = this.$util.getUrlParam('id', data.targetUrl);
							wxAppUrl = this.$util.getUrlParam('path', data.targetUrl);
						} else if (data.type === 8) {
							// 音频
							albumId = this.$util.getUrlParam('id', data.targetUrl);
							nickName = this.$util.getUrlParam('nickName', data.targetUrl);
							albumCount = this.$util.getUrlParam('count', data.targetUrl);
							isPaid = this.$util.getUrlParam('isPaid', data.targetUrl);
						} else if (data.type === 9) {
							aliAppId = this.$util.getUrlParam('appId', data.targetUrl);
							aliAppUrl = this.$util.getUrlParam('page', data.targetUrl);
							let query = this.$util.getUrlParam('query', data.targetUrl);
							if (query) {
								aliAppUrl = aliAppUrl + '&query=' + query;
							}
						} else {
							keyWord = data.targetId;
						}

						this.bannerForm = {
							keyWord: keyWord ? keyWord + '' : '',
							imgUrl: data.imgUrl,
							title: data.title || '',
							clickEvent: data.type + "",
							schObj: {
								shieldedSchools: [],
								openedSchools: [],
								applicableCampus: data.applicableCampus ? data.applicableCampus + "" : "0"
							},
							adExposingCodes: data.adExposingCodes || '',
							positionType: data.positionType + "",
							wxAppId: wxAppId,
							wxAppUrl: wxAppUrl,
							aliAppId: aliAppId,
							aliAppUrl: aliAppUrl,
							albumId: albumId,
							nickName: nickName,
							albumCount: albumCount,
							isPaid: isPaid
						}

						data.applicableCampus == 0 ? (this.bannerForm.schObj.shieldedSchools = data.campusList) : (this.bannerForm.schObj.openedSchools = data.campusList);
					}
				}, (response) => {
					this.$util.errorMsg(response.data.message);
				})
			},

			/**
			 * 新增banner
			 * url /adminapi/v3/operate/banner/add POST
			 *
			 * @param {String} title
			 * @param {String} bannerImage
			 * @param {Nmuber} bannerStatus
			 * @param {Number} publisherUid
			 * @param {Number} type
			 * @param {Object} body: {id: int, url: string}
			**/
			add(status) {
				let createUid = this.user.userId,
					publisherUid = (status === 1) ? 0 : createUid;
				let targetId, targetUrl;
				if (this.bannerForm.clickEvent === '-1') {
					targetId = '';
					targetUrl = '';
				} else if (this.bannerForm.clickEvent === '5' || this.bannerForm.clickEvent === '6') {
					targetUrl = this.bannerForm.keyWord.trim();
					targetId = '';
				} else if (this.bannerForm.clickEvent === '1' || this.bannerForm.clickEvent === '2') {
					targetId = this.bannerForm.keyWord.trim();
					targetUrl = '';
				} else if (this.bannerForm.clickEvent === '7') {
					targetId = '';
					// 小程序的id和url作为两个参数拼成字符串传给后台
					if (this.bannerForm.wxAppUrl && this.bannerForm.wxAppUrl.trim()) {
						targetUrl = 'id=' + this.bannerForm.wxAppId.trim() + '&path=' + this.bannerForm.wxAppUrl.trim();
					} else {
						targetUrl = 'id=' + this.bannerForm.wxAppId.trim();
					}
				} else if (this.bannerForm.clickEvent === '8') {
					//音频
					targetUrl = 'id=' + this.bannerForm.albumId + '&nickName=' + this.bannerForm.nickName
						+ '&count=' + this.bannerForm.albumCount + '&isPaid=' + this.bannerForm.isPaid;
				} else if (this.bannerForm.clickEvent === '9') {
					targetId = '';
					// 小程序的appId和url作为两个参数拼成字符串传给后台
					if (this.bannerForm.aliAppUrl && this.bannerForm.aliAppUrl.trim()) {
						targetUrl = 'appId=' + this.bannerForm.aliAppId.trim() + '&page=' + this.bannerForm.aliAppUrl.trim();
					} else {
						targetUrl = 'appId=' + this.bannerForm.aliAppId.trim();
					}
				}

				let rootUnids = [], iconList = [], schObj = this.bannerForm.schObj;
				if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
					for (let i = 0; i < schObj.shieldedSchools.length; i++) {
						rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1)
					}
				} else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
					for (let i = 0; i < schObj.openedSchools.length; i++) {
						rootUnids.push(schObj.openedSchools[i].rootUnid * 1)
					}
				}

				let requestBody = {
					createUid,
					rootUnids,
					publisherUid: publisherUid,
					targetId: targetId,
					targetUrl: targetUrl,
					applicableCampus: schObj.applicableCampus + "",
					title: this.bannerForm.title.trim(),
					bannerImage: this.bannerForm.imgUrl,
					bannerStatus: status,
					adExposingCodes: this.bannerForm.adExposingCodes.trim(),
					type: this.bannerForm.clickEvent * 1,
					positionType: this.bannerForm.positionType * 1
				}
				if (this.edit) {
					requestBody.id = this.bannerId;
				}
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v3/operate/banner/add',
					body: JSON.stringify(requestBody)
				}).then((response) => {

					if (response.data.error === 10000) {

						location.href = '/#/yunying/banner/bannerManage'

					} else {
						this.$util.errorMsg(response.data.message);
					}

				})
			}
		}
	}
</script>
<style>
	.bannerDetail .bannerForm {
		width: 80%;
	}

	.bannerDetail .el-radio {
		display: block;
		width: 200px;
	}

	.bannerDetail .el-radio+.el-radio {
		margin-left: 0;
	}

	.bannerDetail .el-input {
		margin-top: 10px;
	}

	.bannerDetail .wxApp-from {
		margin-left: 120px;
		margin-bottom: 10px;
	}

	.wx-app {
		margin-bottom: 0;
	}

	.bannerDetail .place {
		width: 30%;
	}

	.bannerContent {
		min-width: 700px;
		width: 70%;
	}

	.gray {
		color: #999;
	}
</style>


// WEBPACK FOOTER //
// newBanner.vue?397563fe